var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.801661 8.01133C0.799187 8.00712 0.799186 8.00189 0.801658 7.99764L5.47869 0.00669526C5.48112 0.00255022 5.48559 0 5.49039 0H14.7605C14.7653 0 14.7698 0.00257209 14.7722 0.00675346L19.398 7.99771C19.4004 8.00189 19.4004 8.00708 19.398 8.01126L14.7722 15.9932C14.7698 15.9974 14.7653 16 14.7605 16H5.49039C5.48559 16 5.48112 15.9975 5.47869 15.9933L0.801661 8.01133ZM14.4089 8C14.4089 10.3791 12.4803 12.3077 10.1013 12.3077C7.7222 12.3077 5.79358 10.3791 5.79358 8C5.79358 5.62091 7.7222 3.69232 10.1013 3.69232C12.4803 3.69232 14.4089 5.62091 14.4089 8Z",
    fill: "#6594A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteel);
export default __webpack_public_path__ + "static/media/steel.57d62b60d552a4e352d299733dfd8e64.svg";
export { ForwardRef as ReactComponent };